/**
 * Custom confirm dialog using jQuery dialog and returning a promise which
 * resolves to a boolean.
 *
 * Note: As with most jQuery, the HTML body must be loaded before calling confirmPlus.
 *
 * @example
 * ```
 * async () => {
 *   let response = await confirmPlus("Select the biohasard symbol.", title="Danger", ok_btn="☣", cancel_btn="☢");
 *   if(!response) alert(`NOOOO! That was the radioactivity sign! We're all going to die!`);
 * }
 *
 * confirmPlus('Do you want this dialog to return "true"?').then(response => {
 *   alert(`The dialog returned ${response}`);
 * });
 *
 * async function askMoney(amount){
 *  if(await confirmPlus(`Can I borrow $${amount}?`, null, null, 'NO!')) alert('Thanks!');
 *  else alert(`Come on man! I'll pay you back from my winnings as soon as I get back from Vegas!`);
 * }
 *
 * askMoney(100);
 * ```
 * @param {string} question 
 * @param {string} [title="Confirm"] 
 * @param {string} [ok_btn="Ok"] 
 * @param {string} [cancel_btn="Cancel"] 
 * @returns {Promise<boolean>}
 */
export function confirmPlus(question, title="Confirm", ok_btn="Ok", cancel_btn="Cancel"){
  let modal = document.createElement('div');
  modal.title = title;
  modal.setAttribute('class', 'modal fade bd-example-modal-sm');
  modal.tabIndex= -1;
  modal.role= 'dialog';
  modal.style.zIndex = 1100;
  modal.innerHTML = `
    <style>
      #cust_confirm_dialog  {
        max-width: 500px;
      }
      #cust_confirm_dialog main {
        text-align: center;
        padding: 2em;
        font-size: 1.5em;
      }

      #cust_confirm_dialog footer {
        padding: 1em;
        text-align: right;
      }
    </style>
    <div id=cust_confirm_dialog class="modal-dialog modal-lg" role=document>
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title">${ title }</h3>
          <button id=cust_confirm_modal_cancel type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <main>${ question }</main>
        <footer>
          <button id=cust_confirm_cancel type="button" class="btn btn-outline-secondary cancel">${ cancel_btn }</button>
          <button id=cust_confirm_confirm type="button" class="btn btn-primary save">${ ok_btn }</button>
        </footer>
      </div>
    </div>
  `
  document.body.appendChild(modal);
  let modal_cancel = document.getElementById('cust_confirm_modal_cancel');
  let cancel = document.getElementById('cust_confirm_cancel');
  let confirm = document.getElementById('cust_confirm_confirm');
  let close = () => {
    $(modal).modal('hide');
    document.body.removeChild(modal);
  }
  $(modal).modal('show');
  return new Promise(res => {
    cancel.onclick = modal_cancel.onclick = () => {
      close();
      res(false);
    }
    confirm.onclick = () => {
      close();
      res(true);
    }
  });
}
